import { __require as y } from "./_baseIsEqual.js";
import { __require as P } from "./get.js";
import { __require as A } from "./hasIn.js";
import { __require as C } from "./_isKey.js";
import { __require as E } from "./_isStrictComparable.js";
import { __require as M } from "./_matchesStrictComparable.js";
import { __require as R } from "./_toKey.js";
var t, o;
function G() {
  if (o) return t;
  o = 1;
  var _ = y(), s = P(), u = A(), m = C(), q = E(), n = M(), f = R(), p = 1, b = 2;
  function c(r, e) {
    return m(r) && q(e) ? n(f(r), e) : function(a) {
      var i = s(a, r);
      return i === void 0 && i === e ? u(a, r) : _(e, i, p | b);
    };
  }
  return t = c, t;
}
export {
  G as __require
};
